import { formApi } from './index'

export async function create(formData, params = {}) {
  return formApi.post('recommendations/upload/', formData, {
    params,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
